import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ButtonComponent, ButtonSizeType, TableColumn, ToastNotificationComponent } from '@ui/aos-lib';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { RequestProcessingService } from '../../services/request-processing.service';
import { RequestProcessingTableRow } from '../../services/request-processing.types';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { TranslateService } from 'src/app/services/translate/translate.service';
import { AsyncPipe } from '@angular/common';
import { take } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastNotificationComponent],
  imports: [ButtonComponent, TranslateModule, AsyncPipe],
  template: `
    @if ((requestProcessingService.cancelPermission$ | async) && item.canCancel === true && item.requestId) {
      <ui-button
        (click)="cancel()"
        [size]="buttonSize"
        [themeColor]="'primary'"
        >{{ cancelLabel | translate }}
      </ui-button>
    }
  `
})
export class RequestProcessingActionsColumnCancelComponent {
  protected readonly requestProcessingService = inject(RequestProcessingService);
  private readonly listingPageService = inject(ListingPageService);
  private readonly toastNotificationComponent = inject(ToastNotificationComponent);
  private readonly translate = inject(TranslateService);

  protected successNotificationTitle =
    TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.NOTIFICATIONS.TITLE.REQUEST_CANCEL_SUCCESS;
  protected successNotificationDetail =
    TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.NOTIFICATIONS.DETAIL.REQUEST_CANCEL_SUCCESS;
  protected failedNotificationTitle =
    TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.NOTIFICATIONS.TITLE.REQUEST_CANCEL_FAILED;
  protected failedNotificationDetail =
    TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.NOTIFICATIONS.DETAIL.REQUEST_CANCEL_FAILED;
  protected readonly cancelLabel = TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.BUTTON.CANCEL;

  @Input() item!: RequestProcessingTableRow;
  @Input() column!: TableColumn;

  protected readonly buttonSize: ButtonSizeType = 'small';

  protected cancel(): void {
    const requestId = this.item.requestId;
    if (!requestId) {
      return;
    }

    this.requestProcessingService
      .cancelRequest(requestId)
      .pipe(take(1))
      .subscribe({
        next: canceled => {
          if (canceled === true) {
            const toastTitle = this.translate.instant(this.successNotificationTitle);
            const toastDetail = this.translate.instant(this.successNotificationDetail);

            this.toastNotificationComponent.showSuccessToast(toastTitle, toastDetail);
            this.listingPageService.refresh();
            return;
          }

          const toastTitle = this.translate.instant(this.failedNotificationTitle);
          const toastDetail = this.translate.instant(this.failedNotificationDetail);
          this.toastNotificationComponent.showErrorToast(toastTitle, toastDetail);
        }
      });
  }
}
